import type { ReactNode } from "react";
import type { LucideIcon } from "lucide-react";

interface EmptyStateProps {
  icon: LucideIcon;
  title: string;
  hint?: string;
  action?: ReactNode;
}

export default function EmptyState({ icon: Icon, title, hint, action }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center text-center py-14">
      <div className="w-14 h-14 rounded-full bg-primary-bg flex items-center justify-center mb-3">
        <Icon size={24} className="text-primary/70" />
      </div>
      <p className="text-[15px] font-semibold text-text-dark">{title}</p>
      {hint && <p className="mt-1 text-[13px] text-text-dark/50 max-w-[240px] leading-relaxed">{hint}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
